import GamesApiService from "@api-services/user/GamesApiService";
import { SSOGamesUserData } from "@api-types/user/SSOGamesUserData";
import { useRootAppStore } from "@hooks";
import { getCurrentCulture } from "@utils";
import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";
import { useTranslation } from "react-i18next";

export function useGamesNavigation() {
	const { userAuthStore } = useRootAppStore();
	const { t } = useTranslation();

	async function handleGamesRedirection() {
		if (
			!userAuthStore.isLoggedIn ||
			!userAuthStore.user ||
			!userAuthStore.token
		) {
			openWindowWithRedirectUrl();
			return;
		}

		const userData: SSOGamesUserData = {
			primary: {
				token: userAuthStore.token,
				userId: userAuthStore.user.id,
				agencyKey: userAuthStore.user.agencyKey,
				shopId: userAuthStore.user.shopId,
				isInternetUser: userAuthStore.user.isInternetUser,
			},
		};

		if (userAuthStore.secondaryUser && userAuthStore.secondaryToken) {
			userData.secondary = {
				token: userAuthStore.secondaryToken,
				userId: userAuthStore.secondaryUser.id,
				agencyKey: userAuthStore.secondaryUser.agencyKey,
				shopId: userAuthStore.secondaryUser.shopId,
				isInternetUser: userAuthStore.secondaryUser.isInternetUser,
			};
		}

		try {
			const redirectResponse =
				await GamesApiService.getRedirectUrl(userData);
			openWindowWithRedirectUrl(redirectResponse.url);
		} catch (error) {
			console.error(error);
			openWindowWithRedirectUrl();
		}
	}

	function openWindowWithRedirectUrl(
		url: string = WEBPACK_GAMES_REDIRECT_BASE_URL +
			`/${getCurrentCulture()}/home`
	) {
		if (isCapacitorPlatform()) {
			window.location.href = url;
		} else {
			const isWindowOpened = window.open(url);
			if (isWindowOpened == null) {
				App.state.rootStore.notificationStore.warning(
					t("COMMON.BLOCK_POPUPS_INFO_MESSAGE")
				);
			}
		}
	}

	return { handleGamesRedirection };
}
